import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button, Col, Form, Input, message, Row, Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import querystring from 'querystring';
import form from '../../../utils/form';
import Paragraph from '../../../components/common/Paragraph';
import InputRut from '../../../components/form/inputs/InputRut';
import { rutValidator } from '../../../utils/validators';
import AloneCol from '../../../components/common/AloneCol';
import TrackingService from '../TrackingService';

const TrackingForm = ({ onEnrollmentHistoryObtain }) => {
  const [isLoading, setLoading] = useState(false);

  const recaptchaRef = useRef();

  const location = useLocation();

  const query = querystring.parse(location.search.substring(1));

  const handleSubmit = async (values) => {
    setLoading(true);

    const recaptcha = await recaptchaRef.current.executeAsync();
    const { rut, trackingNumber } = values;
    const payload = {
      rut: Number(rut.substring(0, rut.length - 1).replace(/[-.]/g, '')),
      trackingNumber: Number(trackingNumber.replaceAll('-', '')),
      recaptcha,
    };
    TrackingService.getEnrollmentHistory(payload)
      .then(({ data }) => onEnrollmentHistoryObtain(data))
      .catch((error) => {
        if (error.status === 400) {
          message.error('La combinación RUT/número de seguimiento no es válida.');
        } else {
          message.error('Ocurrió un error. Intente nuevamente.');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const { rut, trackingNumber } = querystring.parse(location.search.substring(1));

    if (rut && trackingNumber) {
      handleSubmit({ rut, trackingNumber });
    }
  }, [location.search]);

  return (
    <>
      <Spin spinning={isLoading}>
        <Form
          validateMessages={form.validateMessages}
          onFinish={handleSubmit}
          layout="vertical"
          initialValues={query}
        >
          <Row>
            <Col span={24}>
              <Paragraph noBottomMargin strong>
                Consulta el estado de tu solicitud
              </Paragraph>
              <Paragraph>
                Si has realizado una solicitud para hacerte cliente de VanTrust, puedes revisar su
                estado acá.
              </Paragraph>
            </Col>
            <AloneCol span={9} justify="center">
              <Form.Item
                name="rut"
                label="RUT"
                rules={[{ required: true, validator: rutValidator }]}
              >
                <InputRut />
              </Form.Item>
              <Form.Item
                name="trackingNumber"
                label="Número de solicitud"
                normalize={form.normalizers.trackingNumber}
                rules={[{ required: true }]}
              >
                <Input maxLength={13} />
              </Form.Item>
            </AloneCol>
            <AloneCol span={9} justify="center">
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Continuar
                </Button>
              </Form.Item>
            </AloneCol>
          </Row>
        </Form>
      </Spin>
      <ReCAPTCHA
        size="invisible"
        badge="bottomleft"
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY}
      />
    </>
  );
};

TrackingForm.propTypes = {
  onEnrollmentHistoryObtain: PropTypes.func.isRequired,
};

export default TrackingForm;
